import { RoutesType } from 'Shared/Routes';
import { lazy } from 'solid-js';

export function loginRoutes(): RoutesType
{
	return ({
		'/forgotPassword': 					lazy(() => import('Shared/users/ForgotPasswordPage')),
		'/resetPassword/:key': 				lazy(() => import('Shared/users/ResetPasswordPage')),
		'/setPasswordAtRegistration/:key':	lazy(() => import('Shared/users/SetPasswordAtRegistrationPage')),
	});
}

